import { render, staticRenderFns } from "./salesReport.vue?vue&type=template&id=712e177b"
import script from "./salesReport.vue?vue&type=script&lang=js"
export * from "./salesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports